import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { REMOVE_FEATURE_SUBSCRIPTION_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const RemoveFeatureSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_FEATURE_SUBSCRIPTION_RESOURCE,
      method: 'delete',
      request: (appId, installationId, featureId, subscriptionId, callback, resource, t) => ({
        url: apiRoutes.featureSubscriptionDetail(appId, installationId, featureId, subscriptionId),
        meta: {
          callback,
          removeFromOtherList: {
            resource,
            idProp: 'subscriptionId',
            id: subscriptionId,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeFeatureSubscriptionFailed'),
            onSuccessMessage: t('removeFeatureSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveFeatureSubscriptionService;
